import type { Theme } from '@mui/material/styles';

const SEVERITIES = ['error', 'warning', 'success', 'info'] as const;
type Severity = (typeof SEVERITIES)[number];

// Notification "type" (business action, e.g. COUNT/EXPORT) is distinct from `severity`
// (error/warning/success/info): severity says how alarming a notification is, type says what
// action produced it. Non-alerting notifications (severity "info") are colored by type instead,
// so the list reads as "what happened" rather than everything looking like the same generic blue.
// Couleurs prises dans le thème : elles teintent un petit badge d'icône, pas toute la carte.
const TYPE_COLOR: Record<string, (theme: Theme) => string> = {
  COUNT: theme => theme.palette.primary.main,
  EXPORT: theme => theme.palette.success.main,
};

export const severityColor = (theme: Theme, severity: string): string =>
  theme.palette[SEVERITIES.includes(severity as Severity) ? (severity as Severity) : 'info'].main;

export const typeColor = (theme: Theme, type: string): string =>
  TYPE_COLOR[type]?.(theme) ?? theme.palette.text.secondary;
